"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8277],{

/***/ 45111:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "m7 10 5 5 5-5z"
}), 'ArrowDropDown');

exports.Z = _default;

/***/ }),

/***/ 50594:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

exports.Z = _default;

/***/ }),

/***/ 25425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export setTranslateValue */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32793);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1048);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_transition_group__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8662);
/* harmony import */ var _utils_debounce__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(75400);
/* harmony import */ var _utils_useForkRef__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84771);
/* harmony import */ var _styles_useTheme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62097);
/* harmony import */ var _transitions_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(53566);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57577);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


const _excluded = ["addEndListener", "appear", "children", "container", "direction", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];








 // Translate the node so it can't be seen on the screen.
// Later, we're going to translate the node back to its original location with `none`.



function getTranslateValue(direction, node, resolvedContainer) {
  const rect = node.getBoundingClientRect();
  const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
  const containerWindow = (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(node);
  let transform;

  if (node.fakeTransform) {
    transform = node.fakeTransform;
  } else {
    const computedStyle = containerWindow.getComputedStyle(node);
    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
  }

  let offsetX = 0;
  let offsetY = 0;

  if (transform && transform !== 'none' && typeof transform === 'string') {
    const transformValues = transform.split('(')[1].split(')')[0].split(',');
    offsetX = parseInt(transformValues[4], 10);
    offsetY = parseInt(transformValues[5], 10);
  }

  if (direction === 'left') {
    if (containerRect) {
      return `translateX(${containerRect.right + offsetX - rect.left}px)`;
    }

    return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
  }

  if (direction === 'right') {
    if (containerRect) {
      return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
    }

    return `translateX(-${rect.left + rect.width - offsetX}px)`;
  }

  if (direction === 'up') {
    if (containerRect) {
      return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
    }

    return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
  } // direction === 'down'


  if (containerRect) {
    return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
  }

  return `translateY(-${rect.top + rect.height - offsetY}px)`;
}

function resolveContainer(containerPropProp) {
  return typeof containerPropProp === 'function' ? containerPropProp() : containerPropProp;
}

function setTranslateValue(direction, node, containerProp) {
  const resolvedContainer = resolveContainer(containerProp);
  const transform = getTranslateValue(direction, node, resolvedContainer);

  if (transform) {
    node.style.webkitTransform = transform;
    node.style.transform = transform;
  }
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

const Slide = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Slide(props, ref) {
  const theme = (0,_styles_useTheme__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  const defaultEasing = {
    enter: theme.transitions.easing.easeOut,
    exit: theme.transitions.easing.sharp
  };
  const defaultTimeout = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };

  const {
    addEndListener,
    appear = true,
    children,
    container: containerProp,
    direction = 'down',
    easing: easingProp = defaultEasing,
    in: inProp,
    onEnter,
    onEntered,
    onEntering,
    onExit,
    onExited,
    onExiting,
    style,
    timeout = defaultTimeout,
    // eslint-disable-next-line react/prop-types
    TransitionComponent = react_transition_group__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP
  } = props,
        other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(props, _excluded);

  const childrenRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  const handleRefIntermediary = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(children.ref, childrenRef);
  const handleRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(handleRefIntermediary, ref);

  const normalizedTransitionCallback = callback => isAppearing => {
    if (callback) {
      // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
      if (isAppearing === undefined) {
        callback(childrenRef.current);
      } else {
        callback(childrenRef.current, isAppearing);
      }
    }
  };

  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    setTranslateValue(direction, node, containerProp);
    (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_7__/* .reflow */ .n)(node);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntering = normalizedTransitionCallback((node, isAppearing) => {
    const transitionProps = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_7__/* .getTransitionProps */ .C)({
      timeout,
      style,
      easing: easingProp
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, transitionProps));
    node.style.transition = theme.transitions.create('transform', (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, transitionProps));
    node.style.webkitTransform = 'none';
    node.style.transform = 'none';

    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(onEntered);
  const handleExiting = normalizedTransitionCallback(onExiting);
  const handleExit = normalizedTransitionCallback(node => {
    const transitionProps = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_7__/* .getTransitionProps */ .C)({
      timeout,
      style,
      easing: easingProp
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', transitionProps);
    node.style.transition = theme.transitions.create('transform', transitionProps);
    setTranslateValue(direction, node, containerProp);

    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(node => {
    // No need for transitions when the component is hidden
    node.style.webkitTransition = '';
    node.style.transition = '';

    if (onExited) {
      onExited(node);
    }
  });

  const handleAddEndListener = next => {
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(childrenRef.current, next);
    }
  };

  const updatePosition = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(() => {
    if (childrenRef.current) {
      setTranslateValue(direction, childrenRef.current, containerProp);
    }
  }, [direction, containerProp]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    // Skip configuration where the position is screen size invariant.
    if (inProp || direction === 'down' || direction === 'right') {
      return undefined;
    }

    const handleResize = (0,_utils_debounce__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(() => {
      if (childrenRef.current) {
        setTranslateValue(direction, childrenRef.current, containerProp);
      }
    });
    const containerWindow = (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(childrenRef.current);
    containerWindow.addEventListener('resize', handleResize);
    return () => {
      handleResize.clear();
      containerWindow.removeEventListener('resize', handleResize);
    };
  }, [direction, inProp, containerProp]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (!inProp) {
      // We need to update the position of the drawer when the direction change and
      // when it's hidden.
      updatePosition();
    }
  }, [inProp, updatePosition]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TransitionComponent, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
    nodeRef: childrenRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    appear: appear,
    in: inProp,
    timeout: timeout
  }, other, {
    children: (state, childProps) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        ref: handleRef,
        style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
          visibility: state === 'exited' && !inProp ? 'hidden' : undefined
        }, style, children.props.style)
      }, childProps));
    }
  }));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (Slide);

/***/ }),

/***/ 37524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N1": function() { return /* binding */ ScrollableBox; },
/* harmony export */   "OW": function() { return /* binding */ FullscreenModal; },
/* harmony export */   "nv": function() { return /* binding */ InfoModal; },
/* harmony export */   "rK": function() { return /* binding */ FunctionModal; },
/* harmony export */   "tn": function() { return /* binding */ UserDataModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39477);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61953);
/* harmony import */ var _mui_material_Slide__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25425);
/* harmony import */ var _mui_material_Fade__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9942);
/* harmony import */ var _mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58735);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  overflow-y: auto;\n  scrollbar-width: none;\n  border: none;\n  outline: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n\n  @media screen and (min-width: 992px) {\n    width: 540px;\n    height: initial;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}







const functionModalBackdropProps = {
    timeout: 500
};
const Wrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject(), (param)=>{
    let { theme , $autoHeight  } = param;
    return "\n    position: relative;\n    background-color: ".concat(theme.palette.background.paper, ";\n    width: 100%;\n    height: 100%;\n    margin: 0 auto;\n\n    @media screen and (min-width: 992px) {\n      margin-top: 20px;\n      width: 540px;\n      height: ").concat($autoHeight ? "auto" : "737px", ";\n      border-radius: 10px;\n    }\n  ");
});
const ScrollableBox = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject1());
// fullscreen in mobile devices
const FunctionModal = (param)=>{
    let { open , onClose , children , autoHeight , ModalWrapper , ...rest } = param;
    const UsedWrapper = ModalWrapper || Wrapper;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        open: open,
        onClose: onClose,
        closeAfterTransition: true,
        BackdropComponent: _mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
        BackdropProps: functionModalBackdropProps,
        ...rest,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Slide__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            direction: "up",
            in: open,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollableBox, {
                onClick: ()=>onClose && onClose(),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(UsedWrapper, {
                    onClick: (e)=>e.stopPropagation(),
                    $autoHeight: autoHeight,
                    children: children
                })
            })
        })
    });
};
const Fullscreen = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject2(), (param)=>{
    let { theme , $autoHeight  } = param;
    return "\n    position: relative;\n    background-color: ".concat(theme.palette.background.paper, ";\n    width: 100%;\n    height: ").concat($autoHeight ? "auto" : "100%", ";\n    min-height: ").concat($autoHeight ? "100vh" : "auto", ";\n    margin: 0 auto;\n  ");
});
// fullscreen in any devices
const FullscreenModal = (param)=>{
    let { open , onClose , children , autoHeight , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        open: open,
        onClose: onClose,
        closeAfterTransition: true,
        BackdropComponent: _mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
        BackdropProps: functionModalBackdropProps,
        ...rest,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Slide__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            direction: "up",
            in: open,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollableBox, {
                onClick: ()=>onClose && onClose(),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Fullscreen, {
                    onClick: (e)=>e.stopPropagation(),
                    $autoHeight: autoHeight,
                    children: children
                })
            })
        })
    });
};
const InfoWrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject3(), (param)=>{
    let { theme  } = param;
    return "\n    position: relative;\n    background-color: ".concat(theme.palette.background.paper, ";\n    width: calc(100% - 60px);\n    max-width: 540px;\n    height: initial;\n    margin: 0 auto;\n    border-radius: 10px;\n  ");
});
const UserDataWrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject4(), (param)=>{
    let { theme  } = param;
    return "\n    overflow: hidden;\n    position: relative;\n    background-color: ".concat(theme.palette.background.paper, ";\n    width: 354px;\n    height: initial;\n    margin: 0 auto;\n    font-size: 16px;\n    border-radius: 12px;\n    border: 1px solid ").concat(theme.palette.grey.secondary, ";\n    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.05), 0px 2px 4px rgba(0, 0, 0, 0.1);\n  ");
});
// regular modal even in mobile devices
const InfoModal = (param)=>{
    let { open , onClose , children , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        open: open,
        onClose: onClose,
        closeAfterTransition: true,
        BackdropComponent: _mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
        BackdropProps: functionModalBackdropProps,
        ...rest,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Fade__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            in: open,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollableBox, {
                onClick: ()=>onClose && onClose(),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    pt: "150px",
                    pb: "40px",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(InfoWrapper, {
                        onClick: (e)=>e.stopPropagation(),
                        children: children
                    })
                })
            })
        })
    });
};
// user data modal
const UserDataModal = (param)=>{
    let { open , onClose , children , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        open: open,
        onClose: onClose,
        closeAfterTransition: true,
        BackdropComponent: _mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
        BackdropProps: functionModalBackdropProps,
        ...rest,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Fade__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            in: open,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollableBox, {
                onClick: ()=>onClose && onClose(),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    pt: "150px",
                    pb: "40px",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(UserDataWrapper, {
                        onClick: (e)=>e.stopPropagation(),
                        children: children
                    })
                })
            })
        })
    });
};


/***/ }),

/***/ 8277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ common_PopupSearchPanel; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(89289);
// EXTERNAL MODULE: ./node_modules/lodash-es/cond.js
var cond = __webpack_require__(93021);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Popper/Popper.js + 56 modules
var Popper = __webpack_require__(58402);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grow/Grow.js
var Grow = __webpack_require__(61760);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(61953);
// EXTERNAL MODULE: ./components/common/ContentWrapper/index.js
var ContentWrapper = __webpack_require__(55856);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/InputBase/InputBase.js + 1 modules
var InputBase = __webpack_require__(81011);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(70918);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 2 modules
var Button = __webpack_require__(75084);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(79072);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/base/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(23926);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61225);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var useTheme = __webpack_require__(62097);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 3 modules
var emotion_styled_browser_esm = __webpack_require__(77366);
// EXTERNAL MODULE: ./utils/hooks/analytics/GtmAgent/GtmAgent.js
var GtmAgent = __webpack_require__(27582);
// EXTERNAL MODULE: ./store/cache/cacheSlice.js
var cacheSlice = __webpack_require__(24363);
// EXTERNAL MODULE: ./store/webview/webviewSlice.js
var webviewSlice = __webpack_require__(86377);
// EXTERNAL MODULE: ./utils/api/hooks/useKeywords.js
var useKeywords = __webpack_require__(59776);
// EXTERNAL MODULE: ./utils/api/hooks/usePhotoTags.js
var usePhotoTags = __webpack_require__(82688);
// EXTERNAL MODULE: ./config/theme.js + 1 modules
var config_theme = __webpack_require__(26059);
// EXTERNAL MODULE: ./components/common/SVGElements/Search.js
var Search = __webpack_require__(66212);
// EXTERNAL MODULE: ./components/common/SVGElements/SVG.js
var SVG = __webpack_require__(54806);
;// CONCATENATED MODULE: ./components/common/SVGElements/SearchBold.js


const SearchBoldSVG = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SVG/* default */.Z, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            clipPath: "url(#clip0_22219_437485)",
            className: "search-bold",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.5 5.5C2.5 3.84315 3.84315 2.5 5.5 2.5C7.15685 2.5 8.5 3.84315 8.5 5.5C8.5 6.29735 8.18893 7.02205 7.68153 7.55936C7.65967 7.57777 7.63842 7.59727 7.61784 7.61784C7.59727 7.63842 7.57777 7.65967 7.55936 7.68153C7.02205 8.18893 6.29735 8.5 5.5 8.5C3.84315 8.5 2.5 7.15685 2.5 5.5ZM8.25739 9.6716C7.46696 10.1951 6.51908 10.5 5.5 10.5C2.73858 10.5 0.5 8.26142 0.5 5.5C0.5 2.73858 2.73858 0.5 5.5 0.5C8.26142 0.5 10.5 2.73858 10.5 5.5C10.5 6.51908 10.1951 7.46696 9.6716 8.25739L11.2071 9.79284C11.5976 10.1834 11.5976 10.8165 11.2071 11.2071C10.8165 11.5976 10.1834 11.5976 9.79284 11.2071L8.25739 9.6716Z",
                fill: "#4A4A4A"
            })
        })
    });
};

// EXTERNAL MODULE: ./components/common/A/index.js
var A = __webpack_require__(79592);
// EXTERNAL MODULE: ./components/common/Select/index.js
var Select = __webpack_require__(78327);
// EXTERNAL MODULE: ./components/common/Modal/index.js
var Modal = __webpack_require__(37524);
;// CONCATENATED MODULE: ./components/common/PopupSearchPanel/index.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  cursor: pointer;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  padding: 14px 0;\n  font-size: 16px;\n  ",
        "\n\n  > .MuiInputBase-input {\n    padding: 0;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}




























const IconWrapper = emotion_styled_browser_esm/* default.span */.Z.span(_templateObject());
const SearchWrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject1(), (param)=>{
    let { theme , $isLsApp  } = param;
    return "\n    position: ".concat($isLsApp ? "fixed" : "initial", ";\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background-color: white;\n    border: 1px solid ").concat(theme.palette.grey.secondary, ";\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n    border-radius: ").concat($isLsApp ? 0 : "24px", ";\n    z-index: 9999;\n    display: flex;\n    flex-direction: column;\n    max-width: 1600px;\n    margin: auto;\n\n    ").concat(theme.breakpoints.up("lg"), " {\n      bottom: auto;\n      margin: 0 36px;\n    }\n    ").concat(theme.breakpoints.up("xl"), " {\n      margin: 0 48px;\n    }\n    ").concat(theme.breakpoints.up("xxl"), " {\n      margin: 0 auto;\n    }\n  ");
});
const InputPaper = (0,emotion_styled_browser_esm/* default */.Z)(Paper/* default */.Z)(_templateObject2(), (param)=>{
    let { theme  } = param;
    return "\n    padding: 0 10px 0 20px;\n    border-radius: 32px;\n    display: flex;\n    align-items: center;\n    flex: 1;\n    caret-color: ".concat(theme.palette.primary.main, ";\n  ");
});
const SearchInput = (0,emotion_styled_browser_esm/* default */.Z)(InputBase/* default */.ZP)(_templateObject3(), (param)=>{
    let { theme  } = param;
    return "\n    margin-left: ".concat(theme.spacing(2), ";\n  ");
});
const SelectButtonContainer = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject4());
const SelectButton = (0,emotion_styled_browser_esm/* default */.Z)(Box/* default */.Z)(_templateObject5(), (param)=>{
    let { theme , $selected  } = param;
    return "\n    background: ".concat($selected ? theme.palette.primary.main : theme.palette.grey.third, ";\n    color: ").concat($selected ? "#FFFFFF" : "", ";\n    border-radius: 25px;\n    margin-left: 8px;\n    cursor: pointer;\n    &:first-child {\n      margin-left: 24px;\n    }\n    &:hover {\n      background: ").concat($selected ? theme.palette.primary.main : theme.palette.primary.bgPlus1, ";\n    }\n  ");
});
const ItemButton = (0,emotion_styled_browser_esm/* default */.Z)(Button/* default */.Z)(_templateObject6(), (param)=>{
    let { theme  } = param;
    return "\n    &, &:hover {\n      font-weight: initial;\n      color: ".concat(theme.palette.text.minus2, ";\n      padding: ").concat(theme.spacing(2.5), " ").concat(theme.spacing(4), ";\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n      background: ").concat(theme.palette.grey.third, ";\n      border-radius: 25px;\n    }\n    &:hover {\n      background-color: ").concat(theme.palette.primary.bgPlus1, " !important;\n    }\n  ");
});
const genSearchRoute = function(keyword) {
    let type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "article";
    if (type === "article") {
        return "/article/search?keyword=".concat(encodeURIComponent(keyword));
    } else if (type === "album") {
        return "/album/search?keyword=".concat(encodeURIComponent(keyword));
    } else if (type === "vender") {
        return "/vender/search?keyword=".concat(encodeURIComponent(keyword));
    }
    return "/";
};
const SearchContent = (param)=>{
    let { webview , isSmall , isLarge , onClose  } = param;
    const dispatch = (0,es/* useDispatch */.I0)();
    const router = (0,next_router.useRouter)();
    const [keyIn, setKeyIn] = (0,react.useState)("");
    const [keyInSearchType, setKeyInSearchType] = (0,react.useState)("vender");
    const onSearchKeyPress = (event)=>{
        if ((event.charCode === 13 || event.key === "Enter") && !!keyIn) {
            GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
                event: "living_action",
                living_event_name: "search_send",
                living_search_type: {
                    vender: "廠商",
                    article: "文章",
                    album: "圖片"
                }[keyInSearchType],
                living_search_keyword: keyIn,
                living_search_location: "header"
            });
            dispatch((0,cacheSlice/* addSearchRecord */.tk)({
                keyword: keyIn,
                type: keyInSearchType
            }));
            router.push(genSearchRoute(keyIn, keyInSearchType));
            if (onClose) {
                onClose(event);
            }
        }
    };
    const { data: keywords  } = (0,useKeywords/* useKeywords */.N)(()=>keyInSearchType === "article" ? {
            limit: 10
        } : null);
    const { data: photoTags  } = (0,usePhotoTags/* usePhotoTags */.F)(()=>keyInSearchType === "album" ? {
            limit: 10
        } : null);
    const articleSearchRecords = (0,es/* useSelector */.v9)(cacheSlice/* selectArticleSearchRecords */.T1);
    const albumSearchRecords = (0,es/* useSelector */.v9)(cacheSlice/* selectAlbumSearchRecords */.kl);
    const venderSearchRecords = (0,es/* useSelector */.v9)(cacheSlice/* selectVenderSearchRecords */.MB);
    const searchRecords = (0,cond/* default */.Z)([
        [
            ()=>keyInSearchType === "article",
            ()=>articleSearchRecords
        ],
        [
            ()=>keyInSearchType === "album",
            ()=>albumSearchRecords
        ],
        [
            ()=>keyInSearchType === "vender",
            ()=>venderSearchRecords
        ],
        [
            ()=>true,
            ()=>articleSearchRecords
        ]
    ])();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchWrapper, {
        $isLsApp: (webview === null || webview === void 0 ? void 0 : webview.name) === "lsApp" || isSmall,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper/* default */.Z, {
                children: isSmall ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    display: "flex",
                    alignItems: "center",
                    py: 4,
                    position: "relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                            style: {
                                position: "absolute"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                ptr: true,
                                onClick: onClose
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            fontSize: "17px",
                            fontWeight: "fontWeightBold",
                            margin: "auto",
                            children: "搜尋"
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            fontSize: "24px",
                            fontWeight: "600",
                            mt: 6,
                            mb: 2,
                            children: "搜尋"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            ml: 7.5,
                            mt: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                    ptr: true,
                                    onClick: onClose
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper/* default */.Z, {
                display: "flex",
                alignItems: "center",
                mt: 4,
                px: {
                    md: 8
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputPaper, {
                    variant: "outlined",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* SearchSVG */.M, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput, {
                            placeholder: "搜尋" + ({
                                article: "居家文章",
                                album: "居家圖片",
                                vender: "服務廠商"
                            })[keyInSearchType],
                            id: "header-search-input",
                            value: keyIn,
                            onChange: (event)=>setKeyIn(event.target.value),
                            onKeyPress: onSearchKeyPress,
                            inputProps: {
                                inputMode: "search"
                            }
                        }),
                        isSmall ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/img/ic_input_clean_mobile.svg",
                                        style: {
                                            marginRight: "24px"
                                        },
                                        onClick: ()=>{
                                            setKeyIn("");
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select/* default */.Z, {
                                    value: keyInSearchType,
                                    variant: "standard",
                                    $size: "large",
                                    style: {
                                        background: "#F6F6F6",
                                        borderRadius: "25px",
                                        padding: "3px 16px"
                                    },
                                    color: "textPrimary",
                                    iconColor: "textPrimary",
                                    onChange: (e)=>setKeyInSearchType(e.target.value),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "vender",
                                            children: "廠商"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "article",
                                            children: "文章"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "album",
                                            children: "圖片"
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectButtonContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectButton, {
                                    py: 2.5,
                                    px: 4,
                                    onClick: ()=>setKeyInSearchType("vender"),
                                    $selected: keyInSearchType === "vender",
                                    children: "廠商"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectButton, {
                                    py: 2.5,
                                    px: 4,
                                    onClick: ()=>setKeyInSearchType("article"),
                                    $selected: keyInSearchType === "article",
                                    children: "文章"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectButton, {
                                    py: 2.5,
                                    px: 4,
                                    onClick: ()=>setKeyInSearchType("album"),
                                    $selected: keyInSearchType === "album",
                                    children: "圖片"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper/* default */.Z, {
                overflow: "auto",
                px: {
                    md: 8
                },
                children: [
                    !!(searchRecords === null || searchRecords === void 0 ? void 0 : searchRecords.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                mt: 6,
                                mb: 3,
                                display: "flex",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        flexGrow: isLarge ? 0 : 1,
                                        mr: 3,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            color: "text.disabled",
                                            children: "搜尋紀錄"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        fontSize: "medium",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
                                            href: "",
                                            $color: "primary.main",
                                            onClick: ()=>dispatch((0,cacheSlice/* removeAllSearchRecord */.YK)()),
                                            children: "清除"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                container: true,
                                spacing: 3,
                                children: searchRecords === null || searchRecords === void 0 ? void 0 : searchRecords.map((record, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            onClick: (event)=>onClose && onClose(event),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
                                                href: genSearchRoute(record.keyword, record.type),
                                                $origin: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemButton, {
                                                    fullWidth: true,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBoldSVG, {
                                                            width: 12,
                                                            height: 12
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                            ml: 3,
                                                            children: record.keyword
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    }, "record-".concat(index)))
                            })
                        ]
                    }),
                    !!(keywords === null || keywords === void 0 ? void 0 : keywords.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mt: 6,
                                mb: 3,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    color: "text.disabled",
                                    children: "熱門文章標籤"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                container: true,
                                spacing: 3,
                                children: keywords.map((keyword, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            onClick: (event)=>onClose && onClose(event),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
                                                href: "/article/tag/".concat(keyword.urlId),
                                                $origin: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemButton, {
                                                    fullWidth: true,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBoldSVG, {
                                                            width: 12,
                                                            height: 12
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                            ml: 3,
                                                            children: keyword.name
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    }, "keyword-".concat(index)))
                            })
                        ]
                    }),
                    !!(photoTags === null || photoTags === void 0 ? void 0 : photoTags.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mt: 6,
                                mb: 3,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    color: "text.disabled",
                                    children: "熱門標籤"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                container: true,
                                spacing: 3,
                                children: photoTags.map((photoTag, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            onClick: (event)=>onClose && onClose(event),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
                                                href: "/album?tag=".concat(photoTag.urlId),
                                                $origin: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemButton, {
                                                    fullWidth: true,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBoldSVG, {
                                                            width: 12,
                                                            height: 12
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                            ml: 3,
                                                            children: photoTag.name
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    }, "tag-".concat(index)))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mt: {
                            xs: 16,
                            lg: 9
                        }
                    })
                ]
            })
        ]
    });
};
const SearchPanel = (param)=>{
    let { onClose , open  } = param;
    const theme = (0,useTheme/* default */.Z)();
    const isSmall = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("lg"));
    const isLarge = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("lg"));
    const webview = (0,es/* useSelector */.v9)(webviewSlice/* selectWebview */.hn);
    (0,react.useEffect)(()=>{
        setTimeout(()=>{
            if (open && document.getElementById("header-search-input")) {
                document.getElementById("header-search-input").focus();
            }
        }, 500);
    }, [
        open
    ]);
    if (isSmall) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* FunctionModal */.rK, {
            open: open,
            onClose: onClose,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchContent, {
                webview: webview,
                isSmall: isSmall,
                isLarge: isLarge,
                onClose: onClose
            })
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* default */.Z, {
            onClickAway: onClose,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Popper/* default */.Z, {
                open: open,
                transition: true,
                disablePortal: true,
                style: {
                    zIndex: 9999,
                    top: (webview === null || webview === void 0 ? void 0 : webview.name) === "lsApp" || isSmall ? 0 : config_theme/* headerHeight */.J9,
                    right: 0,
                    left: 0
                },
                children: (param)=>/*#__PURE__*/ {
                    let { TransitionProps , placement  } = param;
                    return (0,jsx_runtime.jsx)(Grow/* default */.Z, {
                        ...TransitionProps,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchContent, {
                                webview: webview,
                                isSmall: isSmall,
                                isLarge: isLarge,
                                onClose: onClose
                            })
                        })
                    });
                }
            })
        });
    }
};
const PopupSearchPanel = (param)=>{
    let { onClose , open  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchPanel, {
        onClose: onClose,
        open: open
    });
};
/* harmony default export */ var common_PopupSearchPanel = (PopupSearchPanel);


/***/ }),

/***/ 66212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ SearchSVG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _SVG__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54806);


const SearchSVG = (param)=>{
    let { color , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SVG__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            className: "search",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M4 11a7 7 0 1112.041 4.857 1.005 1.005 0 00-.184.184A7 7 0 014 11zm12.618 7.032a9 9 0 111.414-1.414l3.675 3.675a1 1 0 11-1.414 1.414l-3.675-3.675z",
                className: "Union",
                clipRule: "evenodd"
            })
        })
    });
};


/***/ }),

/***/ 78327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Select__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46541);
/* harmony import */ var _mui_icons_material_ExpandMore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23508);
/* harmony import */ var _mui_icons_material_ArrowDropDown__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45111);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93021);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}






const StyledSelect = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material_Select__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject(), (param)=>{
    let { theme , disabled , $hasSelection , $size , $color  } = param;
    return "\n    font-size: ".concat($size === "large" ? theme.typography.body1.fontSize : $size === "medium" ? "16px" : $size === "small" ? "14px" : theme.typography.h6.fontSize, ";\n\n    &::before, &::after {\n      border-bottom: none !important;\n    }\n\n    #selector {\n      padding-left: 10px;\n      &:focus {\n        background-color: initial;\n      }\n    }\n\n    #service-info {\n      ").concat(disabled ? "background-color: ".concat(theme.palette.background.gray) : "", ";\n    }\n\n    color: ").concat((0,lodash_es__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)([
        [
            ()=>disabled && $hasSelection,
            ()=>theme.palette.text.minus2
        ],
        [
            ()=>disabled && !$hasSelection,
            ()=>theme.palette.text.secondary
        ],
        [
            ()=>$hasSelection,
            ()=>$color === "primary" ? theme.palette.primary.main : theme.palette.text.minus2
        ],
        [
            ()=>true,
            ()=>theme.palette.text.secondary
        ]
    ])(), ";\n    ").concat(disabled ? "background-color: ".concat(theme.palette.background.gray) : "", ';\n    div[role="button"] {\n      ').concat($size === "medium" ? "padding: 12px ".concat($hasSelection ? "32px" : "16px", " 12px 15px;") : "", "\n      ").concat($size === "small" ? "padding: 10px ".concat($hasSelection ? "32px" : "16px", " 10px 10px;") : "", "\n    }\n    ").concat($size === "medium" ? "#selector { padding: 12px ".concat($hasSelection ? "32px" : "16px", " 12px 15px; }") : "", "\n    ").concat($size === "small" ? "#selector { padding: 10px ".concat($hasSelection ? "32px" : "16px", " 10px 10px; }") : "", "\n  ");
});
const StyledExpandMoreIcon = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_icons_material_ExpandMore__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_templateObject1(), (param)=>{
    let { theme  } = param;
    return "\n    fill: ".concat(theme.palette.text.disabled, ";\n  ");
});
const MainTextExpandMoreIcon = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_icons_material_ExpandMore__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_templateObject2(), (param)=>{
    let { theme  } = param;
    return "\n    padding-right:8px;\n    fill: ".concat(theme.palette.text.primary, ";\n  ");
});
const StyledArrowDropDownIcon = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_icons_material_ArrowDropDown__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_templateObject3(), (param)=>{
    let { theme  } = param;
    return "\n    padding-right:8px;\n    fill: ".concat(theme.palette.text.disabled, ";\n  ");
});
const chooseIconByColor = function(color) {
    let size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "medium";
    if (size === "small") {
        return StyledArrowDropDownIcon;
    }
    if (color === "textPrimary") {
        return MainTextExpandMoreIcon;
    }
    return StyledExpandMoreIcon;
};
const Select = (param)=>{
    let { label , value , onChange , disabled , IconComponent , size , color , iconColor , children , muiLabel , labelId , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledSelect, {
        value: value,
        onChange: onChange,
        disabled: disabled,
        label: muiLabel,
        labelId: labelId,
        $hasSelection: !!value || value === 0 || value === false,
        $size: size,
        $color: color,
        ...rest,
        inputProps: {
            id: "selector"
        },
        IconComponent: IconComponent || chooseIconByColor(iconColor, size),
        children: [
            !!(rest === null || rest === void 0 ? void 0 : rest.native) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                value: "",
                disabled: true,
                children: label
            }),
            children
        ]
    });
};
Select.defaultProps = {
    native: true,
    value: "",
    size: "default",
    color: "primary"
};
/* harmony default export */ __webpack_exports__["Z"] = (Select);


/***/ }),

/***/ 59776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useKeywords; }
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86700);


const useKeywords = (props, swrOptions)=>{
    const genUrl = ()=>{
        try {
            const propsObject = typeof props === "function" ? props() : props;
            if (propsObject === null) {
                return null;
            }
            return "/keywords?".concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)(propsObject));
        } catch (err) {
            return null;
        }
    };
    return (0,utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__/* .useCustomSWR */ .LW)(genUrl, swrOptions);
};


/***/ }),

/***/ 82688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ usePhotoTags; }
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86700);


const usePhotoTags = (props, swrOptions)=>{
    const genUrl = ()=>{
        try {
            const propsObject = typeof props === "function" ? props() : props;
            if (propsObject === null) {
                return null;
            }
            return "/photoTags?".concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)(propsObject));
        } catch (err) {
            return null;
        }
    };
    return (0,utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__/* .useCustomSWR */ .LW)(genUrl, swrOptions);
};


/***/ })

}]);